__webpack_require__.p = "/proyectos/mortalidad-infancia/";